import { IAttribute, IModel } from './annotation';
import { Metamodel } from './model';
import { Parameter } from './parameter';
import { Owned } from './named';

@Metamodel.model({
    name: 'parameter value'
})
export class ParameterValue extends Owned {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;
    public static readonly VALUETYPE: IAttribute;

    @Metamodel.attribute({
        type: Parameter.MODEL,
        reference: true
    })
    public parameter: Parameter;

    @Metamodel.attribute({
        constraint: {
            required: false
        },
        association: 'VALUE',
        accepts: ['Any'],
        templatable: true
    })
    public value: string;

    @Metamodel.attribute({
        constraint: {
            required: false
        },
        association: 'VALUETYPE'
    })
    public valueType: string;

    public isExpression: boolean;
}
